<template>
  <page>
    <page-header
      :title="$t('Metabase_MetabaseComputation_Title')"
      :breadcrumbs="breadcrumbs"
    >
      <template slot="actions">
        <el-button
          type="primary"
          @click="manage"
          icon="el-icon-setting"
          v-if="canManage"
        >
          {{ $t('Metabase_MetabaseComputation_ManageComputations') }}
        </el-button>
      </template>
    </page-header>

    <page-content>
      <metabase-computation-list-all />
    </page-content>
  </page>
</template>

<script>
import Page from '@/common/components/page/Page'
import PageHeader from '@/common/components/page/PageHeaderNew'
import { projectRoute, projectEndpoint } from '@/core/helpers'
import RestApi from '@/core/services/RestApi'
import MetabaseComputationListAll from '@/modules/metabase/pages/MetabaseComputationListAll'
import PageContent from '@/common/components/page/PageContent'

export default {
  name: 'MetabaseComputationsPage',

  components: {
    PageContent,
    MetabaseComputationListAll,
    Page,
    PageHeader
  },

  computed: {
    breadcrumbs() {
      return [
        {
          label: this.$t('IntelligenceDashboard_Title'),
          route: projectRoute({
            name: 'CustomerIntelligence'
          })
        },
        {
          label: this.$t('Metabase_MetabaseComputation_Computations')
        }
      ]
    },

    canCompute() {
      return this.$can('MetabaseComputation:FullAccess')
    },

    canManage() {
      return (
        this.$hasFeature('hasMetabaseAccess') &&
        this.$can('MetabaseProject:FullAccess')
      )
    }
  },

  methods: {
    manage() {
      RestApi(
        projectEndpoint({
          method: 'get',
          url: 'metabase/metadata'
        })
      )
        .then(({ data }) => {
          this.$router.push(
            projectRoute({
              name: 'MetabaseProjectApplication',
              query: {
                path: '/collection/' + data.computations_collection_id
              }
            })
          )
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },

    computeAll() {
      RestApi(
        projectEndpoint({
          method: 'post',
          url: 'metabase-computations/compute-all'
        })
      )
        .then(({ data }) => {
          this.$router.push(
            projectRoute({
              name: 'TaskHistoryView',
              query: { id: data.id }
            })
          )
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/metabase/pages/MetabaseComputationsPage.vue